import { render, staticRenderFns } from "./ExclusionZone.page.vue?vue&type=template&id=2fef88b2&scoped=true"
import script from "./ExclusionZone.page.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExclusionZone.page.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ExclusionZone.page.vue?vue&type=style&index=0&id=2fef88b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fef88b2",
  null
  
)

export default component.exports